import * as ActionTypes from "./ActionTypes";
import {ApiManager} from "../api/ApiManager";

export class ModalActions {
    static showModal(toggleModal: boolean) {
        return {type: ActionTypes.SHOW_MODAL, showModal: toggleModal};
    }
    static responseData(responseData: any){
        return {type: ActionTypes.MODAL_CONFIG, responseData: responseData};
    }
    static showPastSession(responseData: any){
        return {type: ActionTypes.FETCH_PATIENT_PAST_SESSIONS_SUCCESS, responseData: responseData};
    }
    static updateModalUIConfig(modalUIConfig: any){
        return {type: ActionTypes.UPDATE_MODAL_UI_CONFIG, modalUIConfig: modalUIConfig}
    }
    static updateFormattedDataAvailable(formattedConfigAvailable: boolean) {
        return {type: ActionTypes.UPDATE_FORMATTED_CONFIG_AVAILABLE, formattedConfigAvailable: formattedConfigAvailable }
    }
    static addSymptomForReview(name: string) {
        return {type: ActionTypes.ADD_SYMPTOM_FOR_REVIEW, name: name}
    }
    static addButtonClicked(status: boolean, name: string) {
        return {type: ActionTypes.ADD_BUTTON_CLICKED, status: status, name: name}
    }
}
